import React from 'react';
import { catalogueService } from '../services/catalogueService';

const CatalogueViewer = ({ studio, studioName, token, onClose }) => {
    const catalogueURL = catalogueService.getCatalogueURL(studio, token);

    // Prevent right-click on PDF
    const handleContextMenu = (e) => {
        e.preventDefault();
        return false;
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.95)',
            zIndex: 10000,
            display: 'flex',
            flexDirection: 'column'
        }}>
            {/* Header */}
            <div style={{
                padding: '20px 40px',
                background: 'rgba(26, 26, 26, 0.9)',
                borderBottom: '1px solid rgba(201, 169, 110, 0.2)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <div>
                    <h3 style={{ 
                        fontSize: '24px', 
                        fontWeight: '300', 
                        color: 'var(--accent-color)',
                        marginBottom: '5px'
                    }}>
                        {studioName}
                    </h3>
                    <p style={{ fontSize: '13px', color: 'rgba(245, 241, 237, 0.6)' }}>
                        🔒 View Only - Download Disabled
                    </p>
                </div>
                <button
                    onClick={onClose}
                    style={{
                        background: 'rgba(255, 255, 255, 0.1)',
                        border: '1px solid rgba(201, 169, 110, 0.3)',
                        color: 'var(--text-light)',
                        padding: '12px 30px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                        e.target.style.background = 'rgba(201, 169, 110, 0.2)';
                    }}
                    onMouseOut={(e) => {
                        e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                    }}
                >
                    ✕ Close
                </button>
            </div>

            {/* PDF Viewer */}
            <div style={{
                flex: 1,
                position: 'relative',
                overflow: 'hidden'
            }}>
                <iframe
                    src={catalogueURL}
                    title={`${studioName} Catalogue`}
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none'
                    }}
                    onContextMenu={handleContextMenu}
                    sandbox="allow-same-origin"
                />
                
                {/* Overlay to prevent interactions that might enable download */}
                <div 
                    onContextMenu={handleContextMenu}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        pointerEvents: 'none'
                    }}
                />
            </div>

            {/* Footer Warning */}
            <div style={{
                padding: '15px 40px',
                background: 'rgba(26, 26, 26, 0.9)',
                borderTop: '1px solid rgba(201, 169, 110, 0.2)',
                textAlign: 'center'
            }}>
                <p style={{ 
                    fontSize: '12px', 
                    color: 'rgba(245, 241, 237, 0.6)',
                    margin: 0
                }}>
                    ⚠️ This catalogue is for viewing purposes only. Downloading, printing, or distributing is not permitted.
                </p>
            </div>
        </div>
    );
};

export default CatalogueViewer;

